/* eslint-disable @typescript-eslint/no-unused-vars */
import {createContext, ReactNode, useMemo, useState} from 'react';

interface ToastState {
  isOpen: boolean;
  message?: string;
}

export const ToastContext = createContext({
  open: (message: string, duration?: number) => {},
  close: () => {}
});

interface Props {
  children: ReactNode;
}

let timer: number;

const ToastProvider = ({children}: Props) => {
  const [state, setState] = useState<ToastState>({isOpen: false});

  const open = (message: string, duration = 3000) => {
    setState({message, isOpen: true});
    timer = window.setTimeout(() => {
      setState({isOpen: false});
    }, duration);
  };

  const close = () => {
    setState({isOpen: false});
    clearTimeout(timer);
  };

  const dispatch = useMemo(() => ({open, close}), []);

  return (
    <ToastContext.Provider value={dispatch}>
      {children}
      {state.isOpen && (
        <div className="toast_g">
          <span className="txt_toast">{state.message}</span>
        </div>
      )}
    </ToastContext.Provider>
  );
};

export default ToastProvider;
